export default {
  propKpiNoCheck: '/honour/client/propKpiNoCheck',
  usePropKpiNoCheck: '/honour/client/usePropKpiNoCheck',
  usePropSettingTips: '/prop/client/usePropSettingTips'
}
